import { Tooltip } from 'antd';
import moment, { ISO_8601 } from 'moment';
import React, { FC } from 'react';
import { FormattedTime } from 'react-intl';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar/avatar';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { Text03, Label01 } from 'components/styles';

const Date = styled.span`
  ${Text03};
  ${Label01};

  line-height: var(--heading-7-line-height);
  min-width: 50px;
  text-align: right;
  white-space: nowrap;
`;

export const UserMessageCommentAvatar: FC<{
  isFromSameUser: boolean;
  userFullName: string;
  createdAt: number;
  avatarUrl?: string;
}> = ({ isFromSameUser, userFullName, createdAt, avatarUrl }) =>
  isFromSameUser ? (
    <Avatar
      alt={userFullName}
      name={userFullName}
      shape="square"
      src={avatarUrl}
      size="large"
    />
  ) : (
    <Tooltip title={<HumanisedDate timestamp={moment(createdAt, ISO_8601)} />}>
      <Date className="user-message__date">
        <FormattedTime value={createdAt} />
      </Date>
    </Tooltip>
  );
